// extracted by mini-css-extract-plugin
export var container = "_9c-0";
export var error = "_9c-9";
export var label = "_9c-5";
export var light = "_9c-6";
export var md = "_9c-3";
export var sm = "_9c-2";
export var thin = "_9c-8";
export var thinBold = "_9c-7";
export var vertical = "_9c-4";
export var xs = "_9c-1";